export default "__VITE_ASSET__DYyRXujS__"